//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPPurchase";
import axios, { CancelToken } from "axios";
// import ChartOTP from "../components/chartOTP.vue";
export default {
  components: {
    chartOTP,
  },
  data() {
    return {
      chartF: {
        ALL: [],
        G1: [],
        G3: [],
        GW: [],
        TRM: [],
      },
      chartS: {
        ALL: [],
        G1: [],
        G3: [],
        GW: [],
        TRM: [],
      },
      chartP: {
        ALL: [],
        G1: [],
        G3: [],
        GW: [],
        TRM: [],
      },
      grp: "NON-NIKE",
      ps: "202001",
      pe: "202053",
      api: `${this.$apiFix}`,
      // apiF: `${this.$apiFix}OTPProcurement.php/fabric`,
      // apiS: `${this.$apiFix}OTPProcurement.php/sew`,
      // apiP: `${this.$apiFix}OTPProcurement.php/pack`,
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadDataFabric();
    this.loadDataSew();
    this.loadDataPack();
  },
  methods: {
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },
    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params,
      }).then((res) => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },

    loadDataFabric() {
      axios
        .get(`${this.api}otp_fabric.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          this.chartF.ALL = response.data;
        });
      axios
        .get(`${this.api}otp_fabric.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G1`)
        .then((response) => {
          this.chartF.G1 = response.data;
        });
      axios
        .get(`${this.api}otp_fabric.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G3`)
        .then((response) => {
          this.chartF.G3 = response.data;
        });
      axios
        .get(`${this.api}otp_fabric.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=GW`)
        .then((response) => {
          this.chartF.GW = response.data;
        });
      axios
        .get(`${this.api}otp_fabric.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=TRM`)
        .then((response) => {
          this.chartF.TRM = response.data;
        });
    },

    loadDataSew() {
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          this.chartS.ALL = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G1`)
        .then((response) => {
          this.chartS.G1 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G2`)
        .then((response) => {
          this.chartS.G2 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G3`)
        .then((response) => {
          this.chartS.G3 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G4`)
        .then((response) => {
          this.chartS.G4 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=GW`)
        .then((response) => {
          this.chartS.GW = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=TRM`)
        .then((response) => {
          this.chartS.TRM = response.data;
        });

    },

    loadDataPack() {
      axios
        .get(`${this.api}otp_pack.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          this.chartP.ALL = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G1`)
        .then((response) => {
          this.chartP.G1 = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=G3`)
        .then((response) => {
          console.log(response.data)
          this.chartP.G3 = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=GW`)
        .then((response) => {
          this.chartP.GW = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nonnike?ps=${this.ps}&pe=${this.pe}&loc=TRM`)
        .then((response) => {
          this.chartP.TRM = response.data;
        });

    },
  },
};
